import { render, staticRenderFns } from "./modal-movie.vue?vue&type=template&id=5eea47b7&"
import script from "./modal-movie.vue?vue&type=script&lang=js&"
export * from "./modal-movie.vue?vue&type=script&lang=js&"
import style0 from "./modal-movie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports